
// app/host-route-config.service.ts
import { Injectable } from '@angular/core';
import hostRouteMap from '@assets/json/host-route-map.json';

export type HostRule =
  | { type: 'exact';  value: string; route: string }
  | { type: 'suffix'; value: string; route: string }
  | { type: 'prefix'; value: string; route: string }
  | { type: 'regex';  value: string; route?: string; routeTemplate?: string };

export interface HostRouteConfig {
  default: string;
  rules: HostRule[];
}

@Injectable({ providedIn: 'root' })
export class HostRouteConfigService {

  // deprecated: carregamento síncrono instead
  //private config: HostRouteConfig = { default: '/home', rules: [] };

  private config: HostRouteConfig = {
    default: typeof hostRouteMap.default === 'string' ? hostRouteMap.default : '/home',
    rules: Array.isArray(hostRouteMap.rules) ? hostRouteMap.rules as HostRule[] : [],
  };


  getConfig(): HostRouteConfig {
    return this.config;
  }

  // deprecated: carregamento síncrono instead
  async load_old(): Promise<void> {
    try {
      const res = await fetch('/assets/json/host-route-map.json', { cache: 'no-store' });
      if (res.ok) {
        const json = await res.json();
        if (json && typeof json === 'object') {
          // validação mínima
          const defaultRoute = typeof json.default === 'string' ? json.default : '/home';
          const rules = Array.isArray(json.rules) ? json.rules : [];
          this.config = { default: defaultRoute, rules };
        }
      }
    } catch {
      // mantém default
      throw new Error('Falha ao carregar host-route-map.json, usando configuração padrão.');
    }
  }


}

